import type { ESignFieldPosition, ESignPageDimensions } from './types';

export function toPixelRect(
  position: ESignFieldPosition,
  pageDimensions: ESignPageDimensions
): { left: number; top: number; width: number; height: number } {
  return {
    left: position.x * pageDimensions.renderedWidth,
    top: position.y * pageDimensions.renderedHeight,
    width: position.width * pageDimensions.renderedWidth,
    height: position.height * pageDimensions.renderedHeight
  };
}
